import {useEffect, useRef} from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "components/maps/utils/leafletCompat";
import { CARTO_TILE_URL, CARTO_TILE_OPTIONS } from 'core/mapsConfig';


const MapPoligonJS = ({id = "map", center, zone, width = "100%", height = "300px", zoom = 13}) => {
    const mapRef = useRef(null);
    const styleZone = {
        color: "#3388ff",
        weight: 4,
        fillColor: "#3388ff",
        fillOpacity: 0.5,
    };

    useEffect(() => {
        // Crear el mapa solo una vez, y solo si center es válido
        const validCenter = Array.isArray(center) && center.length === 2 && Number.isFinite(center[0]) && Number.isFinite(center[1]);
        if (!validCenter) {return}

        if (mapRef.current === null) {
            const map = L.map(id, { zoomAnimation: false, fadeAnimation: false, markerZoomAnimation: false }).setView(center, zoom, {animate:false});

            L.tileLayer(CARTO_TILE_URL, CARTO_TILE_OPTIONS).addTo(map);

            if (zone && Array.isArray(zone.polylines) && zone.polylines.length) {
                // Crear el polígono y añadirlo al mapa
                const polygon = L.polygon(zone.polylines, styleZone).addTo(map);
                // Añadir un popup al polígono
                polygon.bindPopup(`<b>${zone.name}</b>`);
                // Centrar el mapa en el polígono (sin animación para evitar accesos DOM asincrónicos)
                map.fitBounds(polygon.getBounds(), {padding: [50, 50], animate: false});
            }

            // Almacenar el mapa en la referencia
            mapRef.current = map;
        }

        return () => {
            if (mapRef.current) {
                if (mapRef.current.off) mapRef.current.off();
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [center, zone]);

    return <div id={id} style={{width: width, height: height}}></div>;
};

export default MapPoligonJS;
